export default {"src":"/_next/static/media/brand.18b4963d.svg","height":56,"width":202,"blurWidth":0,"blurHeight":0};